import React from "react";
import { MdOutlineArrowLeft } from "react-icons/md";


const Menu = () => {
  return (
    <>
      <section class="text-gray-600 body-font">
        <div class="container px-5 py-12 mx-auto">
          <div class="flex flex-wrap w-full ">
            <div class="lg:w-1/2 w-full ">
              <h1 class="sm:text-3xl text-2xl font-medium title-font mb-2 text-gray-900">
                Our Featured Cuisines
              </h1>
              <div class="h-1 w-20 bg-indigo-500 rounded"></div>
              <div className="flex  text-start">
                <MdOutlineArrowLeft className="lg:w-[25px] lg:h-[25px] " />
                <a href="/">
                  <p className="text-blue-700 ">Back</p>
                </a>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section class="text-gray-600 body-font lg:mt-[-100px]">
        <div class="container px-5 py-24 mx-auto">
          <br />
          <br />
          <div class="lg:flex lg:flex-wrap grid grid-cols-2 -m-4 text-center lg:ml-[200px] ml-[0px]">
            <a href="/Vegetarian">
              <div class="p-4 md:w-1/4 lg:w-[200px]">
                <div class=" bg-gray-100 shadow-lg px-4 py-9 lg:px-4 lg:py-4  rounded-lg  ">
                  <div class="  ">
                    <img
                      src="\Images\Vegetarian\Masala Dosa.jpg"
                      alt="Gobi_Manchurian"
                      name="Gobi_Manchurian"
                      className=" w-60 h-20 rounded-md hover:scale-95 transition-all duration-500 cursor-pointer"
                    />
                  </div>
                  <p
                    className="text-black text-sm font-extrabold mt-5"
                    id="name"
                  >
                    VEGETARIAN
                  </p>
                </div>
              </div>
            </a>
            <a href="/Nonvegetarian">
              <div class="p-4 md:w-1/4 lg:w-[200px]">
                <div class="bg-gray-100 shadow-lg px-4 py-6 lg:px-4 lg:py-4  rounded-lg   ">
                  <div class=" ">
                    <img
                      src="\Images\Nonvegetarian\HYDERABADI DUM BIRYANI.jpg"
                      alt="Gobi_Manchurian"
                      name="Gobi_Manchurian"
                      className=" w-60 h-20 rounded-md hover:scale-95 transition-all duration-500 cursor-pointer"
                    />
                  </div>
                  <p
                    className="text-black text-sm font-extrabold mt-5"
                    id="name"
                  >
                    NON-VEGETARIAN
                  </p>
                </div>
              </div>
            </a>
            <a href="/Sweets">
              <div class="p-4 md:w-1/4 lg:w-[200px]">
                <div class="bg-gray-100 shadow-lg px-4 py-6 lg:px-4 lg:py-4  rounded-lg   ">
                  <div class=" ">
                    <img
                      src="\Images\Sweets\Rasmalai.webp"
                      alt="Gobi_Manchurian"
                      name="Gobi_Manchurian"
                      className=" w-60 h-20 rounded-md hover:scale-95 transition-all duration-500 cursor-pointer"
                    />
                  </div>
                  <p
                    className="text-black text-sm font-extrabold mt-5"
                    id="name"
                  >
                    SWEETS
                  </p>
                </div>
              </div>
            </a>
            <a href="/Beverage">
              <div class="p-4 md:w-1/4 lg:w-[200px]">
                <div class="bg-gray-100 shadow-lg px-4 py-6 lg:px-4 lg:py-4  rounded-lg   ">
                  <div class=" ">
                    <img
                      src="\Images\Beverage\Chai (Masala Tea).jpg"
                      alt="Gobi_Manchurian"
                      name="Gobi_Manchurian"
                      className=" w-60 h-20 rounded-md hover:scale-95 transition-all duration-500 cursor-pointer"
                    />
                  </div>
                  <p
                    className="text-black text-sm font-extrabold mt-5"
                    id="name"
                  >
                    BEVERAGE
                  </p>
                </div>
              </div>
            </a>
          </div>
        </div>
      </section>
    </>
  );
};

export default Menu;
